module.exports = __webpack_public_path__ + "img/wh_cover.ca145e74.jpg";